import { Link2, Mail, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/lib/useAuth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const startAuth = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain-overlay dark-select min-h-screen bg-zinc-950 text-zinc-100 font-body relative overflow-hidden">
      <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#d4af37]/5 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#22d3ee]/5 blur-3xl pointer-events-none" />

      <div className="relative z-10 min-h-screen grid lg:grid-cols-2">
        <div className="flex flex-col justify-between p-10 lg:p-16">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 border border-white/20 rounded-sm flex items-center justify-center">
              <Link2 className="w-4 h-4 text-[#d4af37]" />
            </div>
            <span className="font-heading text-xl tracking-tight">Curator Hub</span>
          </div>
          <div className="max-w-xl">
            <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 mb-6">
              Advantlink · Email · Auto-Publish
            </div>
            <h1 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              Every affiliate email,<br/>
              <span className="text-[#d4af37]">automatically</span> curated.
            </h1>
            <p className="text-zinc-400 mt-8 text-base leading-relaxed max-w-md">
              Forward your Advantlink and merchant emails to a private inbox. We extract every link, let AI tag and title them, and publish a beautiful public directory under your handle.
            </p>
            <button
              data-testid="google-login-btn"
              onClick={startAuth}
              className="mt-10 group inline-flex items-center gap-3 bg-white text-zinc-950 px-6 py-3.5 hover:bg-[#d4af37] transition-colors duration-200 rounded-sm"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
              <span className="font-medium">Continue with Google</span>
            </button>
          </div>
          <div className="text-xs text-zinc-600 mt-10">
            © {new Date().getFullYear()} Curator Hub. Private and secure.
          </div>
        </div>

        <div className="hidden lg:flex flex-col justify-center p-16 border-l border-white/5 bg-gradient-to-b from-white/[0.02] to-transparent">
          <div className="space-y-8 max-w-md">
            {[
              { icon: Mail, title: "Forward, don't paste", body: "A private inbound URL captures your merchant emails the moment they arrive." },
              { icon: Sparkles, title: "AI does the tagging", body: "Claude reads every email, picks the affiliate links, writes titles and picks categories." },
              { icon: Link2, title: "One editorial page", body: "Your fans see a hand-crafted directory. You approve suggestions in a single click." },
            ].map((f) => (
              <div key={f.title} className="flex gap-4">
                <div className="mt-1 w-10 h-10 rounded-sm border border-white/10 bg-white/5 flex items-center justify-center shrink-0">
                  <f.icon className="w-4 h-4 text-[#d4af37]" />
                </div>
                <div>
                  <div className="font-heading text-lg tracking-tight">{f.title}</div>
                  <div className="text-sm text-zinc-400 mt-1 leading-relaxed">{f.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
